import CoreAPIClientError from "@/api/core/CoreAPIClientError";
import { useQuery } from "@tanstack/react-query";
import { FindTenantsQueryResult } from "@ternary/api-lib/core/queries/FindTenantsQuery";
import CoreAPIClient from "../../../api/core/CoreAPIClient";
import { useCoreRequestSender } from "../../../api/CoreRequestSenderProvider";
import { UseQueryOptions, UseQueryResult } from "../../../lib/react-query";
import { queryKeys } from "./queryKeys";

const FAILED_LOADING_MSP_TENANTS = "FAILED_LOADING_MSP_TENANTS";

type TenantEntity = Awaited<ReturnType<CoreAPIClient["getTenants"]>>[number];

type Options = UseQueryOptions<TenantEntity[], CoreAPIClientError> & {
  includeParentTenant?: boolean;
};

export function useGetTenantsByParentTenantID(
  parentTenantID: string,
  options?: Options
): UseQueryResult<TenantEntity[], CoreAPIClientError> {
  const sender = useCoreRequestSender();

  return useQuery({
    queryKey: queryKeys.mspTenants(
      parentTenantID,
      options?.includeParentTenant
    ),
    queryFn: async () => {
      try {
        const searchParams = new URLSearchParams({ parentTenantID });

        if (options?.includeParentTenant) {
          searchParams.set("includeParent", "true");
        }

        const result = (await sender.send(
          `/tenants?${searchParams.toString()}`
        )) as FindTenantsQueryResult;

        return result.tenants;
      } catch (error) {
        console.error(error);

        throw new CoreAPIClientError(FAILED_LOADING_MSP_TENANTS);
      }
    },
    ...options,
  });
}
